import * as React from "react";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "@mui/material";
import axiosInstant from "../../../api";
import TdcVideos from "../../admin/embeds/videoListingPopup/tdcVideos";
import {
  removeVideoFromEmbed,
  addVideoToEmbed,
  getBrandProject,
  getEmbed,
} from "../../../api/endpoints";
import { MainContainer } from "../../../components/ContentWrapper";

export const SelectVideos = () => {
  const { brandId, groupId, projectId } = useParams();
  const [group, setGroup] = useState<any>({});
  const [selectedVideoFileIds, setSelectedVideoFileIds] = useState<
    Array<number>
  >([]);
  const [originalVideoFileIds, setOriginalVideoFileIds] = useState<
    Array<number>
  >([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    fetchProject(projectId);
    fetchGroup(groupId);
  }, [projectId, groupId]);

  React.useEffect(() => {
    if (group?.files?.length > 0) {
      const files = group?.files?.map(
        (e: any) => e?.review?.s3_file_id || e?.id
      );
      setSelectedVideoFileIds(files);
      setOriginalVideoFileIds(files);
    }
  }, [group]);

  const updateSelectedVideos = (videoFileId: number) => {
    const updatedVideos = [...selectedVideoFileIds];
    const videoIndex = selectedVideoFileIds.findIndex((e) => e === videoFileId);
    if (videoIndex > -1) updatedVideos.splice(videoIndex, 1);
    else updatedVideos.push(videoFileId);
    setSelectedVideoFileIds([...updatedVideos]);
  };

  const fetchProject = async (pid: any) => {
    const { data } = await axiosInstant.get(getBrandProject(pid));
    if (data) {
      // setProject(data)
    }
  };

  const fetchGroup = async (gid: any) => {
    const { data } = await axiosInstant.get(getEmbed(gid));
    if (data) setGroup(data);
  };

  const addVideoApi = (fileId: number, embedId: number) =>
    axiosInstant.post(addVideoToEmbed(), { embedId, fileId });
  const removeVideoApi = (fileId: number, gid: number) =>
    axiosInstant.delete(removeVideoFromEmbed(gid, fileId));

  const handleSubmit = async () => {
    if (selectedVideoFileIds.length <= 0) {
      toast.error("Please select at least one video.");
      return;
    }
    const promises = [];

    const cleanedPrevFileIds = originalVideoFileIds.filter((e) => e);

    const newlyAddedIds = selectedVideoFileIds.filter(
      (e) => !cleanedPrevFileIds.includes(e)
    );
    const oldRemovedIds = cleanedPrevFileIds.filter(
      (e) => !selectedVideoFileIds.includes(e)
    );

    promises.push(...newlyAddedIds.map((id) => addVideoApi(id, group.id)));
    promises.push(...oldRemovedIds.map((id) => removeVideoApi(id, group.id)));

    await Promise.all(promises);
    toast.success("Project videos updated.");
    navigate(
      `/brands/${brandId}/projects/${projectId}/group/${groupId}/distribution`
    );
  };

  return (
    <MainContainer title="select videos">
      <TdcVideos
        selectedVideos={selectedVideoFileIds}
        onVideoSelect={updateSelectedVideos}
      />

      <Button
        style={{ float: "right", margin: "0px 20px 20px 0px" }}
        variant="contained"
        onClick={handleSubmit}
      >
        Save
      </Button>
      <Button
        style={{ float: "right", margin: "0px 20px 20px 0px" }}
        variant="outlined"
        onClick={() => {}}
      >
        Cancel
      </Button>
    </MainContainer>
  );
};
